module.exports = __webpack_public_path__ + "img/new_chat_white.65e972a5.svg";